<template>
  <Modal
  v-model="isShow"
  :width="700"
  :loading="loading"
  :mask-closable="false"
  @on-ok="ok"
  >
    <h3 slot="header" class="modal-header">审核活动</h3>
    <Form 
				v-if="activityData"
				ref="reviewData"
				:model="reviewData"
				:rules="ruleValidate"
        style="margin-top:24px"
        :label-width="100">
      <Row>
        <Col span="10">
          <FormItem label="项目名称：">
            <Input v-model="activityData.projectName" type="text" placeholder="项目名称" disabled></Input>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="10">
          <FormItem  label="活动名称：">
            <Input v-model="activityData.activityName" type="text" placeholder="活动名称" disabled></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem  label="活动时间：">
            <Input v-model="activityData.activityDate" type="text" placeholder="活动时间" disabled></Input>
          </FormItem>
        </Col>
      </Row>
      <Row v-for="(itemP,index) in activityTypeDtos" :key="'s1'+index" v-if="activityTypeDtos">
        <Col span="10">
          <FormItem label="活动流程：">
            <Input v-model="itemP.typeName" type="text" placeholder="活动流程" disabled></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem prop="zoCodes" label="参与人：">
            <Input v-model="itemP.zoNames" type="text" placeholder="参与人" disabled></Input>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
      </Row>
      <Row>
        <Col span="20">
          <FormItem label="描述：">
            <Input type="textarea" v-model="activityData.descript" disabled></Input>
          </FormItem>
        </Col>
      </Row>
			<Row>
        <Col span="10">
          <FormItem prop="auditStatus" label="活动审核：">
            <Select v-model="reviewData.auditStatus" placeholder="请选择">
              <Option value=''>请选择</Option>
              <Option v-for="(item,index) in reviewType" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
			<Row>
        <Col span="20">
          <FormItem label="备注：">
            <Input type="textarea" v-model="reviewData.remark"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="30">
          <FormItem label="附件：">
						<img @click="showImg(item2.imgUrl)" v-for="(item2,index2) in activityData.imagesDtos" :key="index2" :src="item2.imgUrl" class="upload">
          </FormItem>
        </Col>
      </Row>
    </Form>
		<img-show :src="imgSrc" :n="showImgKey"></img-show>
  </Modal>
</template>

<script>
import { getProjectZos } from 'api/workOrder'
import {addActivity,findActivityDetail,auditActivity} from 'api/activityManageApi'
import { formatDateTime } from "../../../../../../utils/format";
import ImgShow from 'components/ImgShow/index'

export default {
	components:{
		ImgShow
	},
  props:{
    r: {
      type: Number,
      default: 0
    },
    activityFid:{
      type: String,
      default: '',
    },
  },
  data(){
    return{
			reviewData:{
				remark:'',
				auditStatus:'',
			},
			showImgKey:0,
			imgSrc:'',
			activityData:{},
      isShow: false,
      loading:true,
      zoList:[],
      zoCodes:[],
      imagesDto:[],
			activityTypeDtos:[],
			reviewType:[
				{
					text:'审核通过',
					value:1
				},
				{
					text:'审核驳回',
					value:2
				},
			],
			ruleValidate:{
        auditStatus: [
          { required: true, message: '请选择审核结果', trigger: 'change',type:'number'}
				],
			}
    }
  },
  watch:{
    r(){
			this.$refs['reviewData'].resetFields();
			this.reviewData.remark = ''
      this.isShow = true
      findActivityDetail({
        activityFid:this.activityFid
			})
			.then(res=>{
				this.activityData = res.data
        this.activityTypeDtos = this.activityData.activityTypeDtos
        this.activityData.activityDate = this.format(this.activityData.activityDate)
				console.log(this.activityData)
			})
    },
    
  },
  methods:{
    ok(){ 
      this.$refs['reviewData'].validate( bool => {
        if(bool){
          let params = {
						fid:this.activityFid,
            ...this.reviewData
          }
          auditActivity(params)
          .then( res => {
            console.log(res)
            if(res.code === 0){
              this.$Message.success('审核成功')
              this.$emit('done')
            } else{
              this.$Message.error('审核失败')
            }
          })
          .catch( error => {
            this.$Message.error('审核失败')
          })
          .finally(()=>{
            this.isShow = false
          })
        } else{
          this.changeLoading();
        }
      })
		},
		changeLoading(){
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true
      })
		},
		showImg(data) {
			this.imgSrc = data
			this.showImgKey++
    },
    format(data, showTime = true) {
      if (!data) {
        return ''
      }
      return formatDateTime(data, showTime)
    },
  }
}
</script>

<style scoped>
.upload {
		display: block;
    width: 150px;
    height: 85px;
		border: 1px dashed rgb(220, 220, 220);
		margin: 0 10px 10px 0;
		float: left;
  }
</style>